import { dataMember, required, typedArray } from 'santee-dcts';

export class LabTestIdentity {
    @dataMember()
    @required()
    public zcTestCode: string;
    @dataMember()
    @required()
    public name: string;

    public toString() {
        return this.name;
    }
}

export class LabTestsIdentityReadModel {
    @dataMember()
    @required()
    @typedArray(LabTestIdentity)
    public results: LabTestIdentity[];
}
